/**
 * Given a function, it returns a new function which will return the inverse (on
 * true false, on false true).
 *
 * Example:
 *
 * values.filter(not(Array.isArray));
 */
export const not = fn => x => !fn(x);

/**
 * Given a value, returns a function that returns true given the same value,
 * false otherwise.
 *
 * Example:
 * 	const isFive = equals(5);
 * 	isFive(5) // true
 * 	isFive(1) // false
 */
export const equals = value => x => x == value;
